function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
var FontSizeElement = styled.div.withConfig({
  componentId: "sc-13w8i9j-0"
})(["position:absolute;visibility:hidden;width:1rem;height:0;overflow:hidden;pointer-events:none;"]);
var GlobalFontSizeContext = /*#__PURE__*/createContext(null);
export var useGlobalFontSizeContext = function useGlobalFontSizeContext() {
  return useContext(GlobalFontSizeContext);
};
export var GlobalFontSizeProvider = function GlobalFontSizeProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    fontSize = _useState2[0],
    setFontSize = _useState2[1];
  var fontSizeElementRef = useRef(null);
  useEffect(function () {
    var fontSizeElement = fontSizeElementRef.current;
    if (!fontSizeElement) return;
    var updateFontSize = function updateFontSize() {
      var newFontSize = fontSizeElement.getBoundingClientRect().width;
      setFontSize(newFontSize);
    };
    updateFontSize();
    var resizeObserver = new ResizeObserver(updateFontSize);
    resizeObserver.observe(fontSizeElement);

    // eslint-disable-next-line consistent-return
    return function () {
      resizeObserver.disconnect();
    };
  }, []);
  return /*#__PURE__*/React.createElement(GlobalFontSizeContext.Provider, {
    value: fontSize
  }, children, /*#__PURE__*/React.createElement(FontSizeElement, {
    ref: fontSizeElementRef
  }));
};